module.exports = __webpack_public_path__ + "static/media/arrow-blue-nfg.93f2cf0e.svg";